import React, { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';

import axios from 'axios';
import { Login } from '../pages/Login';
import { MainMenu } from '../pages/MainMenu';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Proyectos } from '../global/proyectos/Proyectos';
import { RecursosHumanos } from '../global/rrhh/RecursosHumanos';
import { Calendario } from '../global/calendario/Calendario';
import { Admin } from '../global/administrador/Admin';
import { Tareas } from '../global/proyectos/tareas/Tareas';
import { Tickets } from '../global/proyectos/tickets/Tickets';
import { Usuarios } from '../global/administrador/usuarios/Usuarios';
import { Notificaciones } from '../global/administrador/notificaciones/Notificaciones';
import { Header } from '../global/Header';
import { Proyecto } from '../global/proyectos/Proyecto';
import { TareasSolicitudes } from '../global/proyectos/tareas/solicitudes/TareasSolicitudes';
import { Fichajes } from '../global/fichaje/Fichajes';
import { RolesYDepartamentos } from '../global/administrador/permisos/RolesYDepartamentos';
import TicketReader from '../utils/componentes-utiles/useTicketReader';
import { FichajesUsuario } from '../global/fichaje/FichajesUsuario';
import { Footer } from '../global/Footer';
import { LateralMenu } from '../global/LateralMenu';
import { Box, Button, Collapse, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { TareaCliente } from '../global/taller/TareaCliente';
import { BtnSubir } from '../utils/BtnSubir';
import { Taller } from '../global/taller/Taller';

// colores de los componentes del MUI
const theme = createTheme({
	palette: {
		primary: {
			main: '#8c0d22',
		},
		secondary: {
			main: '#f1f8e9',
		},
	},

});

const Router = () => {
	//global
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [openDrawer, setOpenDrawer] = useState(
		localStorage.getItem('openDrawer') === 'true'
	);

	useEffect(() => {
		localStorage.setItem('openDrawer', openDrawer);
	}, [openDrawer]);
	return (
		<ThemeProvider theme={theme}>
			<div className='back-main fade-in'>
				<Grid container xs={12} direction={'column'}>
					<Grid container xs={12} direction={'row'}>
						<Header setOpenDrawer={setOpenDrawer} openDrawer={openDrawer} />
					</Grid>
					<Grid container xs={12} direction={'row'}>
						<Grid container xs={12} lg={2} >
							{openDrawer && (
								<LateralMenu setOpenDrawer={setOpenDrawer} openDrawer={openDrawer}></LateralMenu>
							)}
						</Grid>
						<Grid container xs={12} lg={openDrawer ? 10 : 12} sx={{ pb: 10}}>
							<Grid container xs={12} direction={'row'}  >
								<Grid container xs={12} direction={'column'}  >
									<Routes>
										<Route path="/seguimientoparte/:id" element={<TareaCliente />} />
										<Route element={<PrivateRoute />}>
											<Route path="/" element={<MainMenu />}></Route>
											{/* //proyectos */}
											<Route path="/proyectos" element={<Proyectos />}></Route>
											<Route path="/proyecto/:id" element={<Proyecto />}></Route>
											{/* //Taller */}
											<Route path="/taller/" element={<Taller />}></Route>
											{/* //tareas */}
											<Route path="/tareas/:id" element={<Tareas />}></Route>
											{/* //tickets */}
											<Route path="/tickets/:id" element={<Tickets />}></Route>
											{/* //tareas */}
											<Route path="/solicitudes/:id" element={<TareasSolicitudes />}></Route>
											{/* //recursos humanos */}
											<Route path="/rrhh" element={<RecursosHumanos />}></Route>
											{/* //calendario */}
											<Route path="/calendario" element={<Calendario />}></Route>
											{/* //admin */}
											<Route path="/admin" element={<Admin />}></Route>
											{/* //usuarios */}
											<Route path="/usuarios" element={<Usuarios />}></Route>
											{/* //departamentos */}
											<Route path="/rolesydepartamentos" element={<RolesYDepartamentos />}></Route>
											{/* //notificaciones */}
											<Route path="/notificaciones" element={<Notificaciones />}></Route>
											{/* //fichajes */}
											<Route path="/fichajes" element={<Fichajes />}></Route>
											<Route path="/fichajesusuario/:id" element={<FichajesUsuario />}></Route>
										</Route>
										{/* //global */}
										<Route path="/login?" element={<Login username={username} setUsername={setUsername} password={password} setPassword={setPassword} />}></Route>
										<Route path="*" element={<Navigate to="/" replace />} />
									</Routes>
								</Grid>

							</Grid>
						</Grid>
						<BtnSubir></BtnSubir>
						<Footer></Footer>
					</Grid>
				</Grid>

			</div>
		</ThemeProvider >
	)
}

export default Router